export default "__VITE_ASSET__CU$FFOGi__"